import {registerTemplateGraphNode} from "#template/template-node/register"
import {z} from "zod/v4-mini"
import {VariableNode} from "#template/nodes/variable/variable-node"
import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

export type S3VariableParameters = {
    default: [number, number, number, number]
}

const s3VariableDefinition: TemplateNodeDefinition<S3VariableParameters> = {
    nodeClass: "S3Variable",
    validation: {
        parameters: z.object({
            default: z.tuple([z.number(), z.number(), z.number(), z.number()]),
        }),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class S3Variable extends VariableNode<S3VariableParameters> {
    public override get definition() {
        return s3VariableDefinition
    }
}
